import { queryOptions, useQuery } from '@tanstack/react-query';
import { getReadReplicas } from '@/services/api/devops';

export const READ_REPLICAS_QUERY_KEY = ['devops', 'questdb', 'read-replicas'] as const;

export const readReplicasQueryOptions = () =>
  queryOptions({
    queryKey: READ_REPLICAS_QUERY_KEY,
    queryFn: getReadReplicas,
  });

export const useReadReplicas = () => useQuery(readReplicasQueryOptions());
